
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.3.8 (16e44762152643af872b97ec8a256a8b)",
    buildSeed: 1748680937134,
    "wdosbox-x.wasm": {
        "size": 6672487,
        "gzSize": 2409453
    },
    "wdosbox-x.js": {
        "size": 220224,
        "gzSize": 52779
    },
    "wdosbox.wasm": {
        "size": 1458714,
        "gzSize": 499994
    },
    "wdosbox.js": {
        "size": 102407,
        "gzSize": 27644
    },
    "wlibzip.wasm": {
        "size": 113081,
        "gzSize": 52376
    },
    "wlibzip.js": {
        "size": 74502,
        "gzSize": 20042
    }
,
};
